import * as React from "react";

import AuthContext from "src/context/AuthContext";
import PickListContext from "src/context/pickListContext";
import PermissionContext from "src/context/PermissionContext";
import { Redirect } from "react-router-dom";
import { AdminPermissions } from "./Permissions";

// TODO: to get this part working properly, needs to read permissions then change navBar info in context
// when user click to GoAdmin/GoClient just switch navBar items
const LandingPage = () => {
	const { currentUser } = React.useContext(AuthContext);

	if (!currentUser) {
		console.error("User is not logged in");
		return null;
	}

	const orgId = currentUser.tenantId; // Be careful about this part when start to refactor redirecting, GlobalAdmin tenandId is always 1

	let isAdminUser: boolean = false;
	currentUser.permissions!.forEach((p) => {
		if (p === AdminPermissions.GlobalAdmin) {
			isAdminUser = true;
		}
	});

	return isAdminUser ? (
		<Redirect to="/admin/organizations" />
	) : (
		<Redirect to={`/organizations/${orgId}/datasets`} />
	);
};

export default LandingPage;
